const travelPackageStyle = {
  listBox: {
    height: 680,
    width: "100%",
    p: 2,
  },
  customBox2: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2,
  },
  addTravel: {
    p: 3,
    borderRadius: 4,
    mt: 2,
  },
  customBox3: {
    display: "flex",
    gap: 2,
  },
  customFaq: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
  },
  customFaqBox: {
    border: "1px solid #ddd",
    borderRadius: 2,
    p: 2,
    mb: 2,
  },
  buttonBox: {
    display: "flex",
    justifyContent: "space-between",
  },
  customButton: {
    borderRadius: 10,
    width: { xs: "100%", md: "50%" },
    mt: 2,
  },
  inclusionsContainer: {
    maxHeight: 150,
    overflowY: "auto",
    pr: 1,
  },
  inclusionsBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  
  },
};

export default travelPackageStyle;
